import styled, { css } from 'styled-components';

import { proxyUrl } from '@sorare/core/src/atoms/ui/ResponsiveImg';

import defaultBanner from './assets/banner_none.jpg';

type Props = {
  bannerUrl?: string | null;
  bannerColor?: string | null;
  rounded?: boolean;
};

const Root = styled.div<{ rounded?: boolean }>`
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;

  ${props =>
    props.rounded &&
    css`
      border-radius: var(--intermediate-unit);
    `}

  &:after {
    position: absolute;
    content: '';
    inset: 0;
    background: linear-gradient(180deg, rgba(0, 0, 0, 0.4) 0%, #0a0c14 63%);
    ${props =>
      props.rounded &&
      css`
        background: linear-gradient(
          180deg,
          rgba(0, 0, 0, 0.4) 0%,
          var(--c-nd-50-opaque) 63%
        );
        border-radius: var(--intermediate-unit);
      `}
  }
`;

export const Banner = ({ bannerUrl, bannerColor, rounded }: Props) => (
  <Root
    style={{
      backgroundColor: `#${bannerColor || '2d348c'}`,
      backgroundImage: ` url(${
        bannerUrl
          ? proxyUrl(bannerUrl, {
              cropWidth: 1280,
              xl: true,
              dpis: 1,
            })
          : defaultBanner
      })`,
    }}
    rounded={rounded}
  />
);
